<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('live.type1')" class="mb-0">
							<el-select @change="changePlays" v-model="from.domain" size="small" filterable :placeholder="$t('system.select')">
								<!-- <el-option  :label="$t('status.all')" value=""> 
								</el-option>-->
								<el-option v-for="item in agentData" :key="item.id" :label="item.domain" :value="item.domain">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item v-if="type=='1'" :label="$t('live.type2')" class="mb-0">
							<el-select  multiple  v-model="from.plays" size="small" filterable :placeholder="$t('status.all')">
								<!-- <el-option :disabled="true"  :label="$t('status.all')" value=""> 
								</el-option> -->
								<el-option v-for="item in plays" :key="item.id" :label="item.domain" :value="item.domain">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item v-if="type=='1' || type=='2'" :label="$t('live.reg')" class="mb-0">
							<el-select  multiple  v-model="from.reg" size="small" filterable :placeholder="$t('live.allreg')">
								<!-- <el-option :disabled="true"  :label="$t('status.all')" value=""> 
								</el-option> -->
								<el-option v-for="item in regArr" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item label="AppName" class="mb-0">
							<el-input size="small" v-model="from.appname" clearable=""></el-input>
						</el-form-item>
						<el-form-item label="StreamName" class="mb-0">
							<el-input size="small" v-model="from.stream" clearable=""></el-input>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('agentList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						
						
                     
						
						
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<!-- <el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button> -->
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button type="success" size="small" icon="el-icon-download" :loading="liveExcelLoading" @click="downLiveExcel">导出Excel</el-button>
					</div>
			</template>
		</div>
		
		<el-tabs  class="mt-3" v-model="type" @tab-click="handleClick2" >
		     <el-tab-pane  :label="$t('live.pullData')" name="1"></el-tab-pane>
		     <el-tab-pane  :label="$t('live.pushData')" name="2"></el-tab-pane>
		     <el-tab-pane  :label="$t('live.livetran')" name="3"></el-tab-pane>
		     <el-tab-pane  :label="$t('live.recordModel')" name="4"></el-tab-pane>
		     <el-tab-pane  :label="$t('live.liveimg')" name="5"></el-tab-pane>
		</el-tabs>

		<!-- 表格 -->
		<div class="" style="padding-bottom:20px">
			<div style="display: flex; align-items: center;">
				<div>
					<el-tabs type="card"  class="mt-3" v-model="ac_type" @tab-click="handleClick" >
					     <el-tab-pane  :label="$t('live.today')" name="1"></el-tab-pane>
					     <el-tab-pane  :label="$t('live.zuo')" name="2"></el-tab-pane>
					     <el-tab-pane  :label="$t('live.jin7')" name="3"></el-tab-pane>
					     <el-tab-pane  :label="$t('live.jin30')" name="4"></el-tab-pane>
					</el-tabs>
				</div>
				<div class="ml-2" v-if="type=='1' || type=='2'">
					<el-date-picker
						 @change="changeTime"
					      v-model="from.time"
						  :picker-options="pickerOptions"
						  :clearable="false"
					      type="datetimerange"
					      :range-separator="$t('system.to')"
						  popper-class="no-clear-footer"
					      :start-placeholder="$t('system.startTime')"
					      :end-placeholder="$t('system.endTime')">
					    </el-date-picker>
				</div>
				
				<div class="ml-2" v-if="type=='3' || type=='4' || type=='5'">
					<el-date-picker
						 @change="changeTime"
					      v-model="from.time"
						  :picker-options="pickerOptions"
						  :clearable="false"
					      type="daterange"
					      :range-separator="$t('system.to')"
						  popper-class="no-clear-footer"
					      :start-placeholder="$t('system.startTime')"
					      :end-placeholder="$t('system.endTime')">
					    </el-date-picker>
				</div>
			</div>
			
			
		</div>
		
		<!-- 统计 -->
		<div>
			
			<el-row :gutter="20" v-if="type=='1' || type=='2'">
				<el-col :span="12">
					<el-card class="box-card h_100 new_card "  shadow="hover">
					
						<div class="top_card">
							
							<div class="top_title">{{type=='1'?$t('live.bfll'):$t('live.tlll')}}</div>
							<div class="top_info">
								<div>{{type=='1'?bftotal1:tltotal1}} </div>
								<div>{{unit1}} </div>
							</div>
							
						</div>
							
					</el-card>
				</el-col>
				<el-col :span="12">
					<el-card class="box-card h_100 new_card "  shadow="hover">
					
						<div class="top_card">
							
							<div class="top_title">{{type=='1'?$t('live.bfll2'):$t('live.tlll2')}}</div>
							<div class="top_info">
								<div>{{type=='1'?bftotal2:tltotal2}} </div>
								<div>{{unit2}} </div>
							</div>
							
						</div>
							
					</el-card>
				</el-col>
			</el-row>
			
			
			<el-card v-if="type=='3' || type=='4' || type=='5'" class="box-card h_100 new_card "  shadow="hover">
			
				<div class="top_card">
					
					<div class="top_title">{{type=='4'?$t('live.lzmax'):type=='3'?$t('live.tranTotal'):$t('live.imgtotal')}}</div>
					<div class="top_info">
						<div>{{othertotal}} </div>
						<div>{{type=='4'?$t('live.lu'):type=='3'?$t('live.minute'):$t('live.zhang')}} </div>
					</div>
					
				</div>
					
			</el-card>
			
			
		</div>
		
		<!-- 流量 -->
		<div class="mt-3" v-if="type=='1' || type=='2'">
			
			<el-card class="box-card h_100 new_card "  shadow="hover">
				<div slot="header" class="clearfix">
					<span class="body_head">{{$t('live.Flux')}}</span>
					<span class="ml-2" style="color: gray;">({{$t('live.unit')}}: MB)</span>
				</div>

				<div v-show="eData.Flux.length==0" style="position: absolute;width: 100%;">
					<el-empty :image-size="100" :description="$t('safe.none')"></el-empty> 
				</div>
				<div  ref="myChart"  style="height: 300px;">
					
				</div>
					
			</el-card>
		</div>
		<!-- 带宽 -->
		<div class="mt-3"  v-if="type=='1' || type=='2'">
			
			<el-card class="box-card h_100 new_card "  shadow="hover">
				<div slot="header" class="clearfix">
					<span class="body_head">{{$t('live.Bandwidth')}}</span>
					<span class="ml-2" style="color: gray;">({{$t('live.unit')}}: {{cloud_id==5 &&type=='1'?'bps':'Mbps'}})</span>
				</div>
				
				<div v-show="eData.Bandwidth.length==0" style="position: absolute;width: 100%;">
					<el-empty :image-size="100" :description="$t('safe.none')"></el-empty> 
				</div>
				<div  ref="myChart2"  style="height: 300px;">
					
				</div>
					
			</el-card>
		</div>
		
		
		
		<div class="mt-3"  v-if="type=='3' || type=='4' ||  type=='5'">
			
			<el-card class="box-card h_100 new_card "  shadow="hover">
				<div slot="header" class="clearfix">
					<span class="body_head">{{type=='4'?$t('live.lzmax2'):type=='3'?$t('live.tranTotal2'):$t('live.liveimg')}}</span>
					<span class="ml-2" style="color: gray;">({{$t('live.unit')}}: {{type=='4'?$t('live.lu'):type=='3'?$t('live.minute'):$t('live.zhang')}})</span>
				</div>
				
				<div v-show="eData.Bandwidth.length==0" style="position: absolute;width: 100%;">
					<el-empty :image-size="100" :description="$t('safe.none')"></el-empty> 
				</div>
				<div  ref="myChart5"  style="height: 300px;">
					
				</div>
					
			</el-card>
		</div>


		


		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('agentList.edit') : $t('agentList.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
                
                
			
                
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import echarts from 'echarts'
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				liveExcelLoading:false,
				othertotal:0,
				regArr:[],
				unit1:'',
				unit2:'',
				bftotal1:0,
				bftotal2:0,
				tltotal1:0,
				tltotal2:0,
				cloud_id:0,
				createModel: false,
				editIndex: -1,
				plays:[],
				//搜索數据
				from: {
					domain: '',
					plays:[],
					reg:[],
					stream:'',
					appname:'',
					time:[],
				},
				auth_val: 'Agent',
				type:"1",
				ac_type:"1",

				preUrl: "data/livetotalList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delAgent", //删除單条地址
				addUrl: "user/addAgent", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址
				
				tableData: [],
				form: {
                    name: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						tgQrUrl: '',
						tg_qr: '',
						icon:'',
						phone:'',
                        email:'',
                        tg_id:'',
                        share_code:'',
						status: 1,
						parent: 0,
						type: 1,
				},
				rules: {},
				eData:{
					date:[],
					Bandwidth:[],
					Flux:[]
				},
				agentData: [],
				check_img_list:[],
				 // 记录“正在点选”的开始日期（面板内实时）
				      pickingStart: null,
				
				      pickerOptions: null,
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			}
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			const DAY = 24 * 60 * 60 * 1000;
			
			    this.pickerOptions = {
			      onPick: ({ minDate, maxDate }) => {
			        if (minDate) {
			          // ✅ 只按“开始日期”限制，不按开始时间
			          const d = new Date(minDate);
			          d.setHours(0, 0, 0, 0);
			          this.pickingStartDateMs = d.getTime();
			        } else {
			          this.pickingStartDateMs = null;
			        }
			
			        // 选完结束可清理（可选）
			        if (maxDate) {
			          // this.pickingStartDateMs = null;
			        }
			      },
			
			      disabledDate: (time) => {
			        const curMs = time.getTime();
			        const nowMs = Date.now();
			
			        // ✅ 未来日期禁用
			        if (curMs > nowMs) return true;
			
			        // ✅ 限制：开始日期选定后，最多可选 31 个自然日（含最后一天 23:59:59）
			        if (this.pickingStartDateMs != null) {
			          const maxDateMs = this.pickingStartDateMs + 31 * DAY - 1;
			          if (curMs > maxDateMs) return true; // 2/1 会被禁用
			        }
			
			        return false;
			      }
			    };
			//this.commonList('liveStream');
		},
		methods: {
			downLiveExcel(){
				this.liveExcelLoading = true
				this.axios.post('/admin/data/livetotalList', {
					search: this.search || this.from,
					type: this.type,
					ac_type: this.ac_type,
					cloud_id: this.cloud_id,
					export: 1
				}, {
					token: true
				}).then(res => {
					const url = res.data.data.list
					const link = document.createElement('a')
					link.href = url
					link.download = ''
					link.target = '_blank'
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
				}).catch(() => {
					this.$message.error(this.$t('system.openFailed'))
				}).finally(() => {
					this.liveExcelLoading = false
				})
			},
			handleClick2(tab, event) {
				if(this.type!='1' && this.type!='2'){
					this.ac_type = '3'
				}else{
					this.ac_type = '1'
				}
				this.search = this.from
				this.tableData = []
				this.getList()
			},
			disabledDate(time) {
				return true
				console.log('disabledDate called', time);
			  const range = this.from.time
			  if (!range || !range[0]) return false
			
			  const start = new Date(range[0]).getTime()
			  const current = new Date(time).getTime()
			
			  const delta = 31 * 24 * 60 * 60 * 1000
			  const min = start - delta
			  const max = start + delta
			
			  return current < min || current > max
			},
			changeTime(){
				this.ac_type = ''
				this.searchEvent()
				
			},
			
			drawLine() {
				const myChart = echarts.init(this.$refs.myChart);
				 myChart.clear(); 
				if(this.eData.Flux.length==0){
					
					 return false
				}
				
				  const xAxisData = this.eData.date;
				  const seriesData = this.eData.Flux;
								
								
				  myChart.setOption({
				    color: ['#5470C6'],
				
				    tooltip: {
				      trigger: 'axis',
				      formatter: function (params) {
				        const item = params[0];
				        return `${item.axisValue}<br/>${item.data} MB`; // ✅ 只显示时间和值
				      }
				    },
				    legend: {
				      show: false
				    },
				    toolbox: {
				      show: true,
				      right: 20,
				      feature: {
				        dataView: { show: true, readOnly: false, title: this.$t('tool.data') },
				        saveAsImage: { show: true, title: this.$t('tool.down_img') }
				      }
				    },
				    grid: {
				      left: '2%',
				      right: '2%',
				      bottom: '15%',
				      containLabel: true
				    },
				    xAxis: {
				      type: 'category',
				      data: xAxisData,
				      axisLabel: {
				        formatter: val => val.slice(11, 16) // 显示 HH:mm
				      },
				      splitLine: {
				        show: true,
				        lineStyle: {
				          type: 'dashed',
				          color: '#eee'
				        }
				      }
				    },
				    yAxis: {
				      type: 'value',
				      axisLabel: {
				        formatter: '{value} '
				      },
				      splitLine: {
				        show: true,
				        lineStyle: {
				          type: 'dashed',
				          color: '#eee'
				        }
				      }
				    },
				    dataZoom: [
				      {
				        type: 'slider',
				        start: 0,
				        end: 100,
				        bottom: 5
				      },
				      {
				        type: 'inside'
				      }
				    ],
				    series: [
				      {
				        type: 'line',
				        smooth: false,
				        showSymbol: false,
				        data: seriesData
				      }
				    ]
				  });
				

			}

,
			drawLine2() {
				
				const myChart = echarts.init(this.$refs.myChart2);
				 myChart.clear(); 
				if(this.eData.Bandwidth.length==0){
					
					 return false
				}
				  let unit = 'Mbps'
				  // if(this.cloud_id==5){
				  // 	 unit = 'bps'
				  // }
				  const xAxisData = this.eData.date;
				  const seriesData = this.eData.Bandwidth;
								
				  
								
				  myChart.setOption({
				    color: ['#5470C6'],
				
				    tooltip: {
				      trigger: 'axis',
				      formatter: function (params) {
				        const item = params[0];
				        return `${item.axisValue}<br/>${item.data} `+unit; // ✅ 只显示时间和值
				      }
				    },
				    legend: {
				      show: false
				    },
				    toolbox: {
				      show: true,
				      right: 20,
				      feature: {
				        dataView: { show: true, readOnly: false, title: this.$t('tool.data') },
				        saveAsImage: { show: true, title: this.$t('tool.down_img') }
				      }
				    },
				    grid: {
				      left: '2%',
				      right: '2%',
				      bottom: '15%',
				      containLabel: true
				    },
				    xAxis: {
				      type: 'category',
				      data: xAxisData,
				      axisLabel: {
				        formatter: val => val.slice(11, 16) // 显示 HH:mm
				      },
				      splitLine: {
				        show: true,
				        lineStyle: {
				          type: 'dashed',
				          color: '#eee'
				        }
				      }
				    },
				    yAxis: {
				      type: 'value',
				      axisLabel: {
				        formatter: '{value} '
				      },
				      splitLine: {
				        show: true,
				        lineStyle: {
				          type: 'dashed',
				          color: '#eee'
				        }
				      }
				    },
				    dataZoom: [
				      {
				        type: 'slider',
				        start: 0,
				        end: 100,
				        bottom: 5
				      },
				      {
				        type: 'inside'
				      }
				    ],
				    series: [
				      {
				        type: 'line',
				        smooth: false,
				        showSymbol: false,
				        data: seriesData
				      }
				    ]
				  });
				

			}
,

			drawLine4() {
				const chartDom = this.$refs.myChart5;
				if (!chartDom) return false;
			
				// 复用实例，避免重复 init
				let myChart = echarts.getInstanceByDom(chartDom);
				if (!myChart) {
					myChart = echarts.init(chartDom);
				} else {
					myChart.clear();
				}
			
				if (!this.eData || !this.eData.Flux || this.eData.Flux.length === 0) {
					return false;
				}
			
				const unit = this.$t('live.lu');
				const xAxisData = this.eData.date || [];
				const seriesData = this.eData.Flux || [];
			
				// 是否只有一个点
				const isSinglePoint = seriesData.length === 1;
			
				// 是否按天模式：例如 2026-03-05
				const isDayMode = xAxisData.length > 0 && String(xAxisData[0]).length <= 10;
			
				// 计算 y 轴范围，避免只有一个点时看不见
				const maxVal = Math.max(...seriesData.map(v => Number(v) || 0));
				const minVal = Math.min(...seriesData.map(v => Number(v) || 0));
			
				let yAxisMin = null;
				let yAxisMax = null;
			
				if (isSinglePoint) {
					if (maxVal === 0) {
						yAxisMin = 0;
						yAxisMax = 1;
					} else {
						yAxisMin = 0;
						yAxisMax = Math.ceil(maxVal * 1.5);
					}
				} else if (maxVal === minVal) {
					if (maxVal === 0) {
						yAxisMin = 0;
						yAxisMax = 1;
					} else {
						yAxisMin = 0;
						yAxisMax = Math.ceil(maxVal * 1.2);
					}
				}
			
				myChart.setOption({
					color: ['#5470C6'],
			
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							if (!params || !params.length) return '';
							const item = params[0];
							return `${item.axisValue}<br/>${item.data} ${unit}`;
						}
					},
			
					legend: {
						show: false
					},
			
					toolbox: {
						show: true,
						right: 20,
						feature: {
							dataView: {
								show: true,
								readOnly: false,
								title: this.$t('tool.data')
							},
							saveAsImage: {
								show: true,
								title: this.$t('tool.down_img')
							}
						}
					},
			
					grid: {
						left: '2%',
						right: '2%',
						bottom: '15%',
						containLabel: true
					},
			
					xAxis: {
						type: 'category',
						data: xAxisData,
						boundaryGap: isSinglePoint ? true : false,
						axisLabel: {
							formatter: val => {
								if (!val) return '';
								val = String(val);
			
								// 按天：直接显示日期
								if (isDayMode) {
									return val;
								}
			
								// 按5分钟：显示 HH:mm
								if (val.length >= 16) {
									return val.slice(11, 16);
								}
			
								return val;
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
			
					yAxis: {
						type: 'value',
						min: yAxisMin,
						max: yAxisMax,
						axisLabel: {
							formatter: '{value}'
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
			
					dataZoom: xAxisData.length > 1 ? [
						{
							type: 'slider',
							start: 0,
							end: 100,
							bottom: 5
						},
						{
							type: 'inside'
						}
					] : [],
			
					series: [
						{
							type: 'line',
							smooth: false,
							data: seriesData,
							showSymbol: isSinglePoint || seriesData.length <= 10,
							symbol: 'circle',
							symbolSize: isSinglePoint ? 10 : 6,
							connectNulls: true,
							lineStyle: {
								width: 2
							}
						}
					]
				});
			
				// 自适应
				window.addEventListener('resize', () => {
					myChart && myChart.resize();
				});
			}
,
			drawLine3() {
				const chartDom = this.$refs.myChart5;
				if (!chartDom) return false;
			
				// 复用实例，避免重复 init
				let myChart = echarts.getInstanceByDom(chartDom);
				if (!myChart) {
					myChart = echarts.init(chartDom);
				} else {
					myChart.clear();
				}
			
				if (!this.eData || !this.eData.Flux || this.eData.Flux.length === 0) {
					return false;
				}
			
				const unit = this.$t('live.minute');
				const xAxisData = this.eData.date || [];
				const seriesData = this.eData.Flux || [];
			
				// 是否只有一个点
				const isSinglePoint = seriesData.length === 1;
			
				// 是否按天模式：例如 2026-03-05
				const isDayMode = xAxisData.length > 0 && String(xAxisData[0]).length <= 10;
			
				// 计算 y 轴范围，避免只有一个点时看不见
				const maxVal = Math.max(...seriesData.map(v => Number(v) || 0));
				const minVal = Math.min(...seriesData.map(v => Number(v) || 0));
			
				let yAxisMin = null;
				let yAxisMax = null;
			
				if (isSinglePoint) {
					if (maxVal === 0) {
						yAxisMin = 0;
						yAxisMax = 1;
					} else {
						yAxisMin = 0;
						yAxisMax = Math.ceil(maxVal * 1.5);
					}
				} else if (maxVal === minVal) {
					if (maxVal === 0) {
						yAxisMin = 0;
						yAxisMax = 1;
					} else {
						yAxisMin = 0;
						yAxisMax = Math.ceil(maxVal * 1.2);
					}
				}
			
				myChart.setOption({
					color: ['#5470C6'],
			
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							if (!params || !params.length) return '';
							const item = params[0];
							return `${item.axisValue}<br/>${item.data} ${unit}`;
						}
					},
			
					legend: {
						show: false
					},
			
					toolbox: {
						show: true,
						right: 20,
						feature: {
							dataView: {
								show: true,
								readOnly: false,
								title: this.$t('tool.data')
							},
							saveAsImage: {
								show: true,
								title: this.$t('tool.down_img')
							}
						}
					},
			
					grid: {
						left: '2%',
						right: '2%',
						bottom: '15%',
						containLabel: true
					},
			
					xAxis: {
						type: 'category',
						data: xAxisData,
						boundaryGap: isSinglePoint ? true : false,
						axisLabel: {
							formatter: val => {
								if (!val) return '';
								val = String(val);
			
								// 按天：直接显示日期
								if (isDayMode) {
									return val;
								}
			
								// 按5分钟：显示 HH:mm
								if (val.length >= 16) {
									return val.slice(11, 16);
								}
			
								return val;
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
			
					yAxis: {
						type: 'value',
						min: yAxisMin,
						max: yAxisMax,
						axisLabel: {
							formatter: '{value}'
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
			
					dataZoom: xAxisData.length > 1 ? [
						{
							type: 'slider',
							start: 0,
							end: 100,
							bottom: 5
						},
						{
							type: 'inside'
						}
					] : [],
			
					series: [
						{
							type: 'line',
							smooth: false,
							data: seriesData,
							showSymbol: isSinglePoint || seriesData.length <= 10,
							symbol: 'circle',
							symbolSize: isSinglePoint ? 10 : 6,
							connectNulls: true,
							lineStyle: {
								width: 2
							}
						}
					]
				});
			
				// 自适应
				window.addEventListener('resize', () => {
					myChart && myChart.resize();
				});
			}
,
			drawLine5() {
				const chartDom = this.$refs.myChart5;
				if (!chartDom) return false;
			
				// 复用实例，避免重复 init
				let myChart = echarts.getInstanceByDom(chartDom);
				if (!myChart) {
					myChart = echarts.init(chartDom);
				} else {
					myChart.clear();
				}
			
				if (!this.eData || !this.eData.Flux || this.eData.Flux.length === 0) {
					return false;
				}
			
				const unit = this.$t('live.zhang');
				const xAxisData = this.eData.date || [];
				const seriesData = this.eData.Flux || [];
			
				// 是否只有一个点
				const isSinglePoint = seriesData.length === 1;
			
				// 是否按天模式：例如 2026-03-05
				const isDayMode = xAxisData.length > 0 && String(xAxisData[0]).length <= 10;
			
				// 计算 y 轴范围，避免只有一个点时看不见
				const maxVal = Math.max(...seriesData.map(v => Number(v) || 0));
				const minVal = Math.min(...seriesData.map(v => Number(v) || 0));
			
				let yAxisMin = null;
				let yAxisMax = null;
			
				if (isSinglePoint) {
					if (maxVal === 0) {
						yAxisMin = 0;
						yAxisMax = 1;
					} else {
						yAxisMin = 0;
						yAxisMax = Math.ceil(maxVal * 1.5);
					}
				} else if (maxVal === minVal) {
					if (maxVal === 0) {
						yAxisMin = 0;
						yAxisMax = 1;
					} else {
						yAxisMin = 0;
						yAxisMax = Math.ceil(maxVal * 1.2);
					}
				}
			
				myChart.setOption({
					color: ['#5470C6'],
			
					tooltip: {
						trigger: 'axis',
						formatter: function(params) {
							if (!params || !params.length) return '';
							const item = params[0];
							return `${item.axisValue}<br/>${item.data} ${unit}`;
						}
					},
			
					legend: {
						show: false
					},
			
					toolbox: {
						show: true,
						right: 20,
						feature: {
							dataView: {
								show: true,
								readOnly: false,
								title: this.$t('tool.data')
							},
							saveAsImage: {
								show: true,
								title: this.$t('tool.down_img')
							}
						}
					},
			
					grid: {
						left: '2%',
						right: '2%',
						bottom: '15%',
						containLabel: true
					},
			
					xAxis: {
						type: 'category',
						data: xAxisData,
						boundaryGap: isSinglePoint ? true : false,
						axisLabel: {
							formatter: val => {
								if (!val) return '';
								val = String(val);
			
								// 按天：直接显示日期
								if (isDayMode) {
									return val;
								}
			
								// 按5分钟：显示 HH:mm
								if (val.length >= 16) {
									return val.slice(11, 16);
								}
			
								return val;
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
			
					yAxis: {
						type: 'value',
						min: yAxisMin,
						max: yAxisMax,
						axisLabel: {
							formatter: '{value}'
						},
						splitLine: {
							show: true,
							lineStyle: {
								type: 'dashed',
								color: '#eee'
							}
						}
					},
			
					dataZoom: xAxisData.length > 1 ? [
						{
							type: 'slider',
							start: 0,
							end: 100,
							bottom: 5
						},
						{
							type: 'inside'
						}
					] : [],
			
					series: [
						{
							type: 'line',
							smooth: false,
							data: seriesData,
							showSymbol: isSinglePoint || seriesData.length <= 10,
							symbol: 'circle',
							symbolSize: isSinglePoint ? 10 : 6,
							connectNulls: true,
							lineStyle: {
								width: 2
							}
						}
					]
				});
			
				// 自适应
				window.addEventListener('resize', () => {
					myChart && myChart.resize();
				});
			}
,


            
			//提交
			submit() {
				
				this.$refs.form.validate(res => {
					this.form.id = this.editIndex
					this.addOrEdit(this.form)
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list

					//this.layout.loading = false;
				}).catch(err => {
					// 失敗
					//this.layout.loading = false;
				})
			},
			
          
			
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			changePlays(e){
				let info = this.agentData.find(item=>item.domain==this.from.domain);
				if(info){
					this.plays = info.plays
				}else{
					this.plays = []
				}
				if(e){
					this.from.plays = []
				}
				
				//console.log(this.plays)
			},
			getListResult(e) {
				console.log(e)
				if(!this.from.domain){
					this.agentData = e.tl
				}
				this.eData = e.data
				this.from.time = e.time
				this.from.domain = e.domain
				this.from.plays = e.plays
				this.cloud_id = e.cloud_id
				this.regArr = e.regArr
				
				this.changePlays(false)
				
				this.unit1 = e.unit1
				this.unit2 = e.unit2
				if(this.type=='1'){
					this.bftotal1 = e.bftotal1
					this.bftotal2 = e.bftotal2
					
					this.tltotal1 = 0
					this.tltotal2 = 0
				}else{
					this.bftotal1 = 0
					this.bftotal2 = 0
					
					this.tltotal1 = e.tltotal1
					this.tltotal2 = e.tltotal2
				}
				
				this.othertotal = e.othertotal
				
				//his.tableData = e.list
				// this.check_img_list = e.list.map(item=>{
				// 	return item.head
				// })
				if(this.type=='1' || this.type=='2'){
					this.drawLine()
					this.drawLine2()
				}
				if(this.type=='3' ){
					this.drawLine3()
				}
				if(this.type=='4' ){
					this.drawLine4()
				}
				if(this.type=='5' ){
					this.drawLine5()
				}
				
				
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					domain: '',
					stream:'',
					appname:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
.top_card{
	height: 50px;
	display: flex;
	flex-direction: column;
	justify-content: center;
}
.top_title{
	font-size: 14px;
}
.top_info{
	font-size: 20px;
}
.top_info{
	padding-top: 10px;
	display: flex;
	align-items: flex-end;
	
}
.top_info>div:first-child{
	font-size: 20px;
	font-weight: bold;
}
.top_info>div:last-child{
	margin-left: 10px;
	font-size: 14px;
	padding-bottom: 2px;
}

.no-clear-footer .el-picker-panel__footer .el-button--text {
  display: none !important;
}

</style>
